import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../common/TextInput';

const EditAccountForm = (
  {
    account,
    onChange,
    errors,
    onSubmit
  }) => {

  return (
    <div className="genericSettingsPanel center">
      <div className="genericSettingsForm">
        <h5 className="gsp-title">Edit Account</h5>
            
        <TextInput
          name="accountName"
          label="Account Name"
          isRequired={true}
          onChange={onChange}
          placeholder='Account Name'
          value={account.accountName}
          error={errors.accountName || ''} />

        <TextInput
          name="address"
          label="Address"
          isRequired={true}
          onChange={onChange}
          placeholder='Account Name'
          value={account.address}
          error={errors.address || ''} />

        <TextInput
          name="adminName"
          label="Admin Name"
          isRequired={true}
          onChange={onChange}
          placeholder='Admin Name'
          value={account.adminName}
          error={errors.adminName || ''} />

        <TextInput
          name="mobileNumber"
          label="Mobile Number"
          isRequired={true}
          onChange={onChange}
          placeholder='Mobile Number'
          value={account.mobileNumber}
          error={errors.mobileNumber || ''} />

        <div>
          <input className="gsp-button" type="submit" value="Submit" onClick={onSubmit} />
        </div>
      </div>
    </div>
  );
};

EditAccountForm.propTypes = {
  account: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object
};

export  default EditAccountForm;



// WEBPACK FOOTER //
// ./src/components/account/EditAccountForm.js